// The AVATAR STACK visual of a home widget (HOME_WIDGETS_SPEC.md §2): up to
// four 24 px faces overlapping by 6 px, then a "+N" `layer` chip.
//
//   HomeWidgetAvatars: {
//     people: (el, s) => el.call('hrOutNowPeople', s.root)  // [{ key, name, email?, src? }]
//   }
//
// Each face is the house AvatarBundleItem (photo, else initials) at the
// `avatarXs` size. Null = not read yet: one skeleton circle. Hidden at S.
export const HomeWidgetAvatars = {
  class: 'home-widget-visual',
  gridArea: 'visual',
  display: 'none',
  ':is([data-widget-size]:not([data-widget-size="s"])) &': {
    display: 'flex'
  },
  alignItems: 'center',
  alignSelf: 'center',
  minWidth: '0',
  people: null,

  Faces: {
    display: 'flex',
    alignItems: 'center',
    childExtends: 'HomeWidgetFace',
    childrenAs: 'state',
    children: (el) =>
      (Array.isArray(el.parent.people) ? el.parent.people : []).slice(0, 4).map((p, i) => ({
        key: String((p && (p.key || p.email || p.name)) || 'face' + i),
        name: (p && p.name) || '',
        email: (p && p.email) || '',
        avatar: (p && (p.src || p.avatar)) || null
      }))
  },

  More: {
    tag: 'span',
    theme: 'layer',
    round: 'radiusPill',
    padding: 'W2 Y',
    marginInlineStart: 'Y',
    fontFamily: 'Code',
    fontSize: 'Y',
    fontVariantNumeric: 'tabular-nums',
    color: 'caption',
    hide: (el) => !(Array.isArray(el.parent.people) && el.parent.people.length > 4),
    text: (el) => '+' + Math.max(0, ((el.parent.people || []).length || 0) - 4)
  },

  SkeletonCircle: {
    boxSize: 'avatarXs',
    hide: (el) => Array.isArray(el.parent.people)
  }
}

// One face of the stack — the house avatar (IntranetRows.js AvatarBundleItem:
// photo, else initials) at the widget size.
// One face of the stack. The house item paints a translucent `overlayStrong`
// wash in a translucent `overlay` ring — made for opaque posters; on the light
// ambient glass card the circles nearly vanished and overlapping initials ran
// together (crm-w1's live check, "DMND"). The stack is the widget's ONE visual
// (HOME_WIDGETS_SPEC §2), so a face takes the widget's hue and the hue's
// measured ink — the plate's own pair, published by the frame as
// --home-widget-hue / --home-widget-hue-ink — and its ring is the CARD's own
// surface, so an overlap reads as a cut between two circles on any skin and
// scheme.
export const HomeWidgetFace = {
  extends: 'AvatarBundleItem',
  marginInlineEnd: '-Y',
  borderColor: 'var(--home-card-bg, var(--theme-card-background))',
  BundlePlate: {
    width: 'avatarXs',
    height: 'avatarXs',
    fontSize: 'Y',
    background: '--home-widget-hue',
    color: '--home-widget-hue-ink'
  }
}
